import { ReactNode, createContext, useContext, useMemo } from 'react';

import { usePublicSubdomainViewToken } from '@/api/auth/getViewToken';

export type ViewTokenContextType = {
    loading: boolean;
    viewToken: string | null;
};

const defaultViewTokenContextData: ViewTokenContextType = {
    loading: false,
    viewToken: null,
} as const;

const ViewTokenContext = createContext(defaultViewTokenContextData);

export const PublicViewTokenContextProvider = ({ children }: { children: ReactNode }) => {
    const { isPending, data } = usePublicSubdomainViewToken();

    const contextValue = useMemo(
        () => ({ loading: isPending, viewToken: data?.data.viewToken ?? null }),
        [data, isPending]
    );

    return <ViewTokenContext.Provider value={contextValue}>{children}</ViewTokenContext.Provider>;
};

export const useViewToken = () => useContext(ViewTokenContext);
